import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TableRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      roleToChange: '',
    };
  }

  tableLabels = () => {
    return Object.keys(this.props.data[0]);
  };

  handleRoleChange = (e) => {
    this.setState({
      roleToChange: e.target.value,
    });
  };

  render() {
    const { roleToChange } = this.state;
    return (
      <>
        <tr key={this.props.user.id}>
          {this.tableLabels().map((key) => (
            <td key={`${this.props.user.id}${key}`}>{this.props.user[key]}</td>
          ))}
          {this.props.user.editable ? (
            <>
              <select
                onChange={(e) => {
                  this.handleRoleChange(e);
                }}
              >
                <option value="" selected disabled hidden>
                  Select Role
                </option>
                {this.props.editableRoles.map((role) => {
                  return (
                    <option key={role} value={role}>
                      {role}
                    </option>
                  );
                })}
              </select>
              <br />
              <button
                disabled={roleToChange.length === 0}
                type="submit"
                onClick={() => {
                  this.props.handleSubmit(roleToChange, this.props.user);
                }}
              >
                Submit
              </button>
            </>
          ) : (
            'Not editable'
          )}
        </tr>
      </>
    );
  }
}

TableRow.propTypes = {
  data: PropTypes.array.isRequired,
};
